export const BLOCKED_PROVIDERS = ['LMSL Vietnam', 'LMSL Romania', 'LMSL Indonesia', 'ILMS'];

export const BLOCKED_LANGUAGES = ['Romanian', 'Vietnamese'];
